module.exports = __webpack_public_path__ + "media/dashboard/assets/images/ai-assist-c463e5794a091a0c609889339769c70b.svg";